import { Add } from "@mui/icons-material";
import { Box, Button, Container, Tab } from "@mui/material";
import React, { useState } from "react";
import HistoryGroup from "./HistoryGroup";
import PendingGroup from "./PendingGroup";
import ViewGroup from "./ViewGroup";
import HeaderHelpPage from "../HeaderHelpPage";
import { writeLog } from "../../services/services";
import TabsMenu from "../TabsMenu";
import { TabPanel } from "@mui/lab";
import { styles } from "../../utils/styles";
import CreateNewGroup from "../../pages/Admin/CreateNewGroup";

const GroupSwitchView = ({ userRole }) => {
  const [selectedView, setSelectedView] = useState("All");
  const [createDialog, setCreateDialog] = useState(false);

  const handleChange = (event, value) => {
    setSelectedView(value);
  };
  return (
    <Container>
      <HeaderHelpPage title="Admin Role" description="User group specifies what user could see or able to do for each category." />
      <TabsMenu value={selectedView} onChange={handleChange}>
        <Tab label="All" value="All" />
        <Tab label="Pending" value="Pending" />
        <Tab label="History" value="History" />
        {userRole.includes("Add") && selectedView === "All" && (
          <Box>
            <Button
              variant="contained"
              onClick={() => {
                writeLog('[Info] - Click button [Add new group] - Open new tab to Create A New Group')
                setCreateDialog(true)
              }}
              startIcon={<Add />}
              sx={{ ...styles.customButton }}
            >
              Add New Group
            </Button>
          </Box>
        )}
        
        <TabPanel value="All">
          <ViewGroup userRole={userRole} />
        </TabPanel>
        <TabPanel value="Pending">
          <PendingGroup userRole={userRole} />
        </TabPanel>
        <TabPanel value="History">
          <HistoryGroup userRole={userRole} />
        </TabPanel>
      </TabsMenu>

      {createDialog && <CreateNewGroup open={true} onClose={() => setCreateDialog(false)} />}
    </Container>
  );
};

export default GroupSwitchView;
